/*
 * Copyright (c) 2023. Collabro Limited
 */

import React, { useContext } from "react";
import { Backdrop, LinearProgress, Typography } from "@mui/material";
import { AuthenticatedContext } from "../Authenticated/Authenticated";
import Loading from "../Helper/Loading";
import RosterPanelTable from "../RosterPanelTable/RosterPanelTable";
import AnimatedLogo from "../Helper/AnimatedLogo";
import NoLocations from "../Helper/NoLocations";

const DashboardContainer = () => {
  const { reportDataFetching, reportDataLoading, currentLocation } =
    useContext(AuthenticatedContext);

  //If the current location is UNK (e.g. person does not have any locations setup in Vantage)
  if (currentLocation!.location === "UNK") {
    return <NoLocations />;
  }

  if (reportDataLoading) {
    return <Loading fullHeight />;
  }

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 5,
          backgroundColor: "rgb(0 0 0 / 0%)",
          top: 120,
        }}
        open={reportDataFetching}
      >
        <div
          style={{
            width: "20%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <AnimatedLogo />
          <Typography color="primary" sx={{ textAlign: "center" }}>
            Loading Roster
          </Typography>
          <LinearProgress color="secondary" />
        </div>
      </Backdrop>
      <RosterPanelTable loading={reportDataFetching} />
    </>
  );
};

export default DashboardContainer;
